import { Icon } from '@brighterion/br-ui';
import clsx from 'clsx';
import React from 'react';

import styles from './ModalTitleFileNameAndSize.css';

type Props = {
    // default to CSV
    iconName?: string;
    fileName: string;
    fileSize: string;
    hasError?: boolean;
    containerClassName?: string;
};
const ModalTitleFileNameAndSize = ({ iconName, fileName, fileSize, hasError, containerClassName }: Props) => {
    return (
        <div className={clsx(styles.fileDetails, containerClassName)}>
            <Icon
                className={clsx(styles.icon, hasError && styles.errorIcon)}
                size='xlg'
                name={iconName ?? 'csv-file'}
            />
            <p data-testid='bulk-file-details' className={styles.fileName}>
                {fileName} <span className={styles.fileSize}>{fileSize}</span>
            </p>
        </div>
    );
};

export default ModalTitleFileNameAndSize;
